import(/* webpackMode: "eager" */ "/home/user/azagent/_work/1/s/apps/dashboard/src/app/[locale]/error.tsx");
